"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WasfatyAllergy_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var WasfatyAllergy_Factory = /** @class */ (function () {
    function WasfatyAllergy_Factory() {
    }
    WasfatyAllergy_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
            Id: model.Id,
        };
        return result;
    };
    WasfatyAllergy_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
            Id: model.Id,
        };
        return result;
    };
    return WasfatyAllergy_Factory;
}());
exports.WasfatyAllergy_Factory = WasfatyAllergy_Factory;
